export default {
  "errors.noValue": "*This field is required",
  "errors.incorrectCard": "*Incorrect card number",
  "errors.incorrectName": "*Name is incorrect",
  "errors.incorrectExpiry": "*Incorrect expiry date",
  "errors.incorrectCvv": "*Incorrect cvv",
  "errors.incorrectEmail": "*Email is incorrect",
  "errors.incorrectPhone": "*Phone is incorrect",
}